var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayerPause = function SvgPlayerPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 52 52"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#playerPause_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#191919"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#playerPause_svg__b)",
    stroke: "url(#playerPause_svg__c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M35.563 14.313H30.78c-.587 0-1.062.475-1.062 1.062v21.25c0 .587.475 1.063 1.062 1.063h4.782c.586 0 1.062-.476 1.062-1.063v-21.25c0-.587-.476-1.062-1.062-1.062"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#playerPause_svg__d)",
    stroke: "url(#playerPause_svg__e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.219 14.313h-4.782c-.586 0-1.062.475-1.062 1.062v21.25c0 .587.476 1.063 1.063 1.063h4.78c.588 0 1.063-.476 1.063-1.063v-21.25c0-.587-.475-1.062-1.062-1.062"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "playerPause_svg__b",
    x1: 33.172,
    x2: 33.172,
    y1: 14.313,
    y2: 37.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playerPause_svg__c",
    x1: 33.172,
    x2: 33.172,
    y1: 14.313,
    y2: 37.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B7F8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playerPause_svg__d",
    x1: 18.828,
    x2: 18.828,
    y1: 14.313,
    y2: 37.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playerPause_svg__e",
    x1: 18.828,
    x2: 18.828,
    y1: 14.313,
    y2: 37.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B7F8A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "playerPause_svg__a",
    width: 52,
    height: 56,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.6875 0 0 0 0 0.6875 0 0 0 0 0.6875 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1_23"
  })))));
};
export default SvgPlayerPause;